import React, { useEffect } from 'react';
import Layout from 'components/Layout';
import { useSelector } from 'react-redux';
import { useGetVirtualCoffeeAnalyticsQuery } from 'app/services/home';
import { useGetPlanQuery } from 'app/services/payment';
import localStorage from 'utils/localStorage';
import GamesOverview from 'components/GamesOverview';
import { identify, track } from 'utils/segment';
import GameCards from './GameCards';
import styles from './styles.module.scss';
import Trend from './Trend';
import VcLimits from './VcLimits';

const Home = () => {
  const platform = localStorage.getPlatform();
  const { data: virtualCoffee = { leftOut: 0 } } = useGetVirtualCoffeeAnalyticsQuery(undefined, {
    skip: platform === 'teams'
  });
  const { data: planDetails = { plan: '', hasSubscription: false } } = useGetPlanQuery();
  const userDetails = useSelector((state) => state.user);

  useEffect(() => {
    if (!userDetails.loading) {
      const { _id, loggedUsersCount = 0 } = userDetails;
      if (_id) {
        identify(_id, { 'Unique Logged In Users': loggedUsersCount });
        track('Visit Dashboard', {
          distinct_id: _id,
          Page: 'Home',
          Date: new Date(),
          'Unique Logged In Users': loggedUsersCount
        });
      }
    }
  }, [userDetails]);

  return (
    <Layout name='Home' className={styles.homeContentWrapper}>
      <div className={styles.welcomeText}>
        Welcome, {userDetails.user?.fullname?.trim().split(' ')[0]}!
      </div>
      <GamesOverview />
      {planDetails.plan === 'BASIC' && <Trend type='restricted' />}
      <GameCards planDetails={planDetails} />
      {platform === 'slack' && planDetails.plan === 'BASIC' && virtualCoffee.leftOut > 0 && (
        <VcLimits leftOut={virtualCoffee.leftOut} />
      )}
      {(userDetails.freeTrial ||
        ['STANDARD', 'PRO'].includes(userDetails.plan) ||
        planDetails.hasSubscription) && <Trend type='engagement' />}
    </Layout>
  );
};

export default Home;
